import { render, staticRenderFns } from "./DocumentRadioCard.vue?vue&type=template&id=c9354c98&"
import script from "./DocumentRadioCard.vue?vue&type=script&lang=js&"
export * from "./DocumentRadioCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRadioCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports